/* eslint-disable */
const powershellScript = `
Parameters to be updated depending on environment and Image Delivery Keys

$q: URL to the Image Delivery WS
$key: Image Information Key supplied per environment


$q = new-webserviceproxy('https://us.personalcard.net/AllAboutMe/Services/PCS/Dispatch.asmx');
$q;
$key = 'XXXXXXXXX-XXXX-XXXX-XXXXX-XXXXXXXXXXXX';
$key;
$file = Get-Content Images.txt;
$file;
Foreach($image in $file) {
                $r = $q.GetImage($image, $key);
                $r;
                [System.IO.File]::WriteAllBytes('C:\temp\' +$image+'.jpg', $r.Image);
}`;

export default powershellScript ;